// @flow
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";
import { textFieldDefaults } from "../../../../helpers/theme/defaultProps";

type Props = {
	name: string,
	required?: boolean,
	value: string,
	onChange: Function,
	onBlur?: Function,
	allowBrowserAutocomplete?: boolean,
	otherProps?: Object
};

const PasswordInput = (props: Props) => {
	const {
		name,
		required = false,
		value,
		onChange = () => {
		},
		onBlur = () => {
		},
		allowBrowserAutocomplete,
		label,
		otherProps = {}
	} = props
	const [showPassword, setShowPassword] = useState(false);
	const handleClickShowPassword = () => setShowPassword((show) => !show);
	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};
	return (
        <TextField
			{...textFieldDefaults}
			name={name}
			required={required}
			type={showPassword ? 'text' : 'password'}
			value={value}
			onChange={onChange}
			onBlur={onBlur}
			sx={{
				'& .MuiOutlinedInput-root': {
					':focus-within': { border: '0.0px solid #ffffff !important' },
					bgcolor: "background.paper"
				},
			}}
			{...otherProps}
			slotProps={{
				htmlInput: {
					"aria-label": label
				},
				input: {
					maxLength: '100',
					autoComplete: 'current-password',
					...(!allowBrowserAutocomplete && {
						autoComplete: 'new-password',
						form: {
							autoComplete: 'off',
						},
					}),
					"aria-label": label,
					endAdornment: (
						<InputAdornment position="end">
							<IconButton
								aria-label="toggle password visibility"
								onClick={handleClickShowPassword}
								onMouseDown={handleMouseDownPassword}
								edge="end"
							>
								{showPassword ? <VisibilityOff/> : <Visibility/>}
							</IconButton>
						</InputAdornment>
					)
				}
			}}
		/>
    );
};

export default PasswordInput